import { Injectable } from '@angular/core';
import { CookieService } from '../cookie/cookie.service';

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
  private readonly key = 'cookie_consent';
  private readonly expiraonDays = 360;

  constructor(private cookie: CookieService) {}

  hasConsent(): boolean {
    return this.cookie.getCookie(this.key) === 'true';
  }

  giveConsent(): void {
    this.cookie.setCookie(this.key, 'true', this.expiraonDays);
  }

  revokeConsent(): void {
    this.cookie.deleteCookie(this.key);
  }
}
